(function(){
  var backdrop;
  var currentProduct;
  var currentVariant;

  function icon(){
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.15 14.1V9.85a1.9 1.9 0 0 0-1.9-1.9H5.45a1.9 1.9 0 0 0-1.9 1.9v7.35a1.9 1.9 0 0 0 1.9 1.9h9.35"></path><path d="M6.7 7.95V6.55a2.3 2.3 0 0 1 2.3-2.3h2.7a2.3 2.3 0 0 1 2.3 2.3v1.4"></path><circle class="plus-clear" cx="17.2" cy="16.7" r="3.3"></circle><path class="bag-plus" d="M17.2 14.5v4.4M15 16.7h4.4"></path></svg>';
  }

  function checkIcon(){
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.2 4.2L19 7" style="fill:none;stroke:currentColor;stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round"></path></svg>';
  }

  function productData(card){
    var source=card&&card.querySelector('.quick-product-data');
    if(!source)return null;
    try{return JSON.parse(source.textContent)}catch(error){return null}
  }

  function decorate(){
    document.querySelectorAll('.product-hover-card').forEach(function(card){
      var data=productData(card);
      var quick=card.querySelector('.quick-add');
      if(!quick)return;
      if(quick.dataset.quickReady==='true')return;
      quick.setAttribute('role','button');
      quick.setAttribute('tabindex','0');
      var title=data?data.title:(card.querySelector('h3')?card.querySelector('h3').textContent.trim():'product');
      quick.setAttribute('aria-label','Choose '+title);
      quick.innerHTML=icon();
      quick.classList.toggle('has-choices',!data||data.variants.length>1);
      quick.dataset.quickReady='true';
    });
  }

  function ensureModal(){
    if(backdrop)return;
    backdrop=document.createElement('div');
    backdrop.className='quick-buy-backdrop';
    backdrop.innerHTML='<section class="quick-buy-modal" role="dialog" aria-modal="true" aria-label="Choose product options"><button class="quick-buy-close" type="button" aria-label="Close">&times;</button><div class="quick-buy-media"></div><div class="quick-buy-info"><h2></h2><div class="quick-buy-price"></div><p class="quick-buy-label">Size</p><div class="quick-buy-variants"></div><div class="quick-buy-actions"><div class="quick-buy-purchase-row"><div class="quick-buy-quantity"><button type="button" data-quick-minus>&minus;</button><input type="number" min="1" value="1" aria-label="Quantity"><button type="button" data-quick-plus>+</button></div><button class="quick-buy-add" type="button">'+icon()+' Add to cart</button></div><button class="quick-buy-now" type="button">Buy it now</button><p class="quick-buy-error" role="status"></p></div></div></section>';
    document.body.appendChild(backdrop);
    backdrop.addEventListener('click',function(event){
      if(event.target===backdrop||event.target.closest('.quick-buy-close'))closeModal();
    });
  }

  function selectVariant(button){
    var id=button.getAttribute('data-variant-id');
    currentVariant=currentProduct.variants.find(function(variant){return String(variant.id)===id});
    backdrop.querySelectorAll('.quick-buy-variant').forEach(function(item){item.classList.toggle('is-active',item===button)});
    var add=backdrop.querySelector('.quick-buy-add');
    if(add)add.disabled=false;
  }

  function showModal(data){
    currentProduct=data;
    if(!currentProduct||!currentProduct.variants.length)return;
    currentVariant=null;
    ensureModal();
    var media=backdrop.querySelector('.quick-buy-media');
    media.innerHTML=currentProduct.images.slice(0,2).map(function(src){return '<img src="'+src+'" alt="">'}).join('');
    backdrop.querySelector('.quick-buy-info h2').textContent=currentProduct.title;
    backdrop.querySelector('.quick-buy-price').innerHTML='<span>'+currentProduct.price+'</span>'+(currentProduct.comparePrice?'<s>'+currentProduct.comparePrice+'</s>':'');
    var variants=backdrop.querySelector('.quick-buy-variants');
    variants.innerHTML='';
    currentProduct.variants.forEach(function(variant,index){
      var button=document.createElement('button');
      button.type='button';
      button.className='quick-buy-variant';
      button.setAttribute('data-variant-id',variant.id);
      button.textContent=variant.title;
      button.disabled=false;
      button.addEventListener('click',function(){selectVariant(button)});
      variants.appendChild(button);
      if((variant.available!==false && !currentVariant) || (index===0 && !currentProduct.variants.some(function(item){return item.available!==false;})))selectVariant(button);
    });
    backdrop.querySelector('.quick-buy-quantity input').value=1;
    var addButton=backdrop.querySelector('.quick-buy-add');
    addButton.innerHTML=icon()+' Add to cart';
    addButton.classList.remove('is-added');
    addButton.disabled=false;
    backdrop.querySelector('.quick-buy-error').textContent='';
    backdrop.classList.add('is-open');
    document.body.style.overflow='hidden';
  }

  function openModal(card){
    var data=productData(card);
    if(data){
      showModal(data);
      return;
    }
    var link=card.querySelector('h3 a');
    if(!link)return;
    var productUrl=link.getAttribute('href').split('?')[0];
    fetch(productUrl+'.js',{headers:{Accept:'application/json'}}).then(function(response){
      if(!response.ok)throw new Error('Unable to load product');
      return response.json();
    }).then(function(product){
      var format=function(cents){return '$'+(Number(cents||0)/100).toFixed(2)};
      showModal({
        title:product.title,
        url:product.url||productUrl,
        price:format(product.price),
        comparePrice:product.compare_at_price&&product.compare_at_price>product.price?format(product.compare_at_price):null,
        images:(product.images||[]).slice(0,4),
        variants:(product.variants||[]).map(function(variant){
          return {id:variant.id,title:variant.title,available:variant.available,price:format(variant.price)};
        })
      });
    });
  }

  function closeModal(){
    if(backdrop)backdrop.classList.remove('is-open');
    document.body.style.overflow='';
  }

  function quantity(){
    return Math.max(1,parseInt(backdrop.querySelector('.quick-buy-quantity input').value,10)||1);
  }

  function addToCart(){
    if(!currentVariant){
      backdrop.querySelector('.quick-buy-error').textContent='Please choose a size.';
      return;
    }
    var button=backdrop.querySelector('.quick-buy-add');
    button.disabled=true;
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8','Accept':'application/json'},
      body:'id='+encodeURIComponent(currentVariant.id)+'&quantity='+encodeURIComponent(quantity())
    }).then(function(response){
      return response.text().then(function(raw){
        var result; try{result=JSON.parse(raw)}catch(error){result={description:raw.slice(0,180)}}
        if(!response.ok)throw new Error(result.description||result.message||'Unable to add this item');
        return result;
      });
    }).then(function(){
      button.innerHTML=checkIcon();
      button.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('kajun:cart-updated'));
      window.setTimeout(function(){
        if(!button.isConnected)return;
        button.innerHTML=icon()+' Add to cart';
        button.classList.remove('is-added');
        button.disabled=false;
      },1600);
    }).catch(function(error){
      backdrop.querySelector('.quick-buy-error').textContent=error.message;
      button.disabled=false;
    });
  }

  document.addEventListener('click',function(event){
    var quick=event.target.closest('.quick-add');
    if(quick){
      event.preventDefault();
      event.stopPropagation();
      openModal(quick.closest('.product-hover-card'));
      return;
    }
    if(!backdrop)return;
    if(event.target.closest('[data-quick-minus]'))backdrop.querySelector('.quick-buy-quantity input').value=Math.max(1,quantity()-1);
    if(event.target.closest('[data-quick-plus]'))backdrop.querySelector('.quick-buy-quantity input').value=quantity()+1;
    if(event.target.closest('.quick-buy-add'))addToCart();
    if(event.target.closest('.quick-buy-now')&&currentVariant)window.location.href='/cart/'+currentVariant.id+':'+quantity()+'?checkout';
  },true);

  document.addEventListener('keydown',function(event){
    if(event.key==='Escape')closeModal();
    var quick=event.target.closest&&event.target.closest('.quick-add');
    if(quick&&(event.key==='Enter'||event.key===' ')){event.preventDefault();openModal(quick.closest('.product-hover-card'))}
  });

  document.addEventListener('pointerover',function(event){
    var card=event.target.closest&&event.target.closest('.product-hover-card');
    if(card)decorate();
  });

  document.addEventListener('DOMContentLoaded',function(){setTimeout(decorate,50);setTimeout(decorate,650)});
  setTimeout(decorate,700);
  new MutationObserver(decorate).observe(document.documentElement,{childList:true,subtree:true});
})();
